import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';

import { RephraseIcon } from '../../../../icons/prompt/rephrase';
import { createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptionsFactory,
	EditorPluginAIConfigItemFactory,
} from '../../config-items';

const intentSchemaId = 'rephrase.json';

export const rephrase: EditorPluginAIConfigItemFactory = (options) => ({
	key: CONFIG_ITEM_KEYS.REPHRASE,
	title: aiConfigItemMessages.rephraseTitle,
	description: aiConfigItemMessages.rephraseDescription,
	icon: () => <RephraseIcon />,
	statusLozengeType: 'beta',
	intentSchemaId,
	featureId: 'rephrase',
	getBackendModel: () => 'assistance-service',
	actions: {
		empty: [
			createInsertBelow({ appearance: 'secondary', factoryOptions: options }),
			createReplace({ appearance: 'primary' }),
		],
		selection: [
			createInsertBelow({ appearance: 'secondary', factoryOptions: options }),
			createReplace({ appearance: 'primary' }),
		],
	},
});

export const rephraseWithOptions: EditorPluginAIConfigItemWithOptionsFactory = (options) => ({
	config: rephrase(options),
	triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: true } },
});
